import constant from '@/constant.js'
import util from '@/util.js'

export default {
  getOrders: function (userId, cb) {
    var data = { userId: Number(userId), sort: 'id', desc: true }
    util.apiHandler('post', `${constant.API_ROOT}/orderInfo/findByCondition`, data, cb)
  },
  getOrder: function (id, cb) {
    util.apiHandler('post', `${constant.API_ROOT}/orderInfo/findbyid/${id}`, null, cb)
  },
  getOrderGoods: function (orderId, cb) {
    var data = { orderId: Number(orderId) }
    util.apiHandler('post', `${constant.API_ROOT}/orderGoods/findByCondition`, data, cb)
  },
  getPayments: function (cb) {
    util.apiHandler('get', `${constant.API_ROOT}/payment/list`, null, cb)
  },
  getOrderPrice: function (order, cb) {
    util.apiHandler('post', `${constant.API_ROOT}/orderInfo/checkPriceAndInventory`, order, cb)
  },
  createOrder: function (order, cb) {
    util.apiHandler('post', `${constant.API_ROOT}/orderInfo/createOrder`, order, cb)
  },
  payOrder: function (orderId, cb) {
    util.apiHandler('post', `${constant.API_ROOT}/orderInfo/orderPay`, orderId, cb)
  },
  sendOrderEmail: function (orderId, cb) {
    util.apiHandler('post', `${constant.API_ROOT}/orderInfo/orderNotify`, orderId, cb)
  }
}
